import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';

export default function StatCard({ children, title, subtitle }) {
    return (
        <Card>
            {title && (
                <CardHeader>
                    <CardTitle>{title}</CardTitle>
                    {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
                </CardHeader>
            )}
            {children}
        </Card>
    );
}

const Card = styled.div`
    background: ${colors.neutralLight};
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 8px ${colors.night}08;
    border: 1px solid ${colors.night}11;
    height: 100%;
`;

const CardHeader = styled.div`
    margin-bottom: 20px;
`;

const CardTitle = styled.h3`
    font-size: 16px;
    font-weight: 600;
    color: ${colors.nightDark};
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CardSubtitle = styled.p`
    font-size: 13px;
    color: ${colors.night};
    margin: 0;
`;
